import React from "react";
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";

import { XStackContainer } from "../../Containers";
import { SliderFormControl } from "../Web/SliderFormControl";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration; control: SliderFormControl } {
    let ui = new FormConfiguration();
    const container = new XStackContainer();

    const slider = new SliderFormControl();

    container.add(slider);

    ui.add(container);

    return { form: ui, control: slider };
}

export const SliderStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Slider",
        "Default"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "With Label";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Slider",
        "With Label"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.label = "Show Min Max Marks";
            ui.control.showMinMaxValues = true;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Slider",
        "Show Min Max Marks"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.max = 100;
            ui.control.step = 20;
            ui.control.label = "Step: 20";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Slider",
        "With Step"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.control.max = 100;
            ui.control.step = 20;
            ui.control.defaultValue = 20;

            ui.control.label = "Default Value: 20";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Slider",
        "With Default"
    ),
];
